import { Controller } from '@hotwired/stimulus'

import TimeAgo from 'javascript-time-ago'
import ru from 'javascript-time-ago/locale/ru'
import en from 'javascript-time-ago/locale/en'
import sr from 'javascript-time-ago/locale/sr'

TimeAgo.addDefaultLocale(en)
TimeAgo.addLocale(ru)
TimeAgo.addLocale(sr)

export default class extends Controller {
  static values = {
    datetime: String,
    interval: { type: Number, default: 10_000 },
    locale: { type: String, default: 'en' }
  }

  connect() {
    const datetime = this.datetimeValue
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    const el = this.element

    this.calculateTimeAgo(datetime, tz, el)

    setInterval(() => this.calculateTimeAgo(datetime, tz, el), this.intervalValue)
  }

  calculateTimeAgo(datetime, tz, el) {
    const formatted_date = new Date(datetime.toLocaleString(this.localeValue, { timeZone: tz }).replace(/-/g, "/"))

    const timeAgo = new TimeAgo(this.getLocalWithCountry(this.localeValue))
    el.innerHTML = timeAgo.format(formatted_date)
  }

  getLocalWithCountry(locale) {
    return `${locale}-${Intl.DateTimeFormat().resolvedOptions().region}`
  }
}
